<!-- Container-fluid starts -->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">

        <form
          [formGroup]="registerForm"
          class="form theme-form"
          (ngSubmit)="register()">

          <div class="card-body">
            <div class="row">
              <div class="col">

                <!-- Scheduled Date -->
                <div class="form-group row mb-3">
                  <label class="col-sm-3 col-form-label">
                    Scheduled Date
                  </label>

                  <div class="col-sm-9">
                    <input
                      type="date"
                      formControlName="scheduledDate"
                      class="form-control"
                      [ngClass]="{
                        'is-invalid':
                          submitted && f['scheduledDate'].errors
                      }" />

                    <div
                      *ngIf="submitted && f['scheduledDate'].errors"
                      class="invalid-feedback">

                      <div *ngIf="f['scheduledDate'].errors['required']">
                        Scheduled Date is required
                      </div>
                    </div>
                  </div>
                </div>
   <div class="form-group row mb-3">
                  <label class="col-sm-3 col-form-label">
                    Time
                  </label>

                  <div class="col-sm-9">
                    <input
                      type="time"
                      formControlName="time"
                      class="form-control"
                      [ngClass]="{
                        'is-invalid':
                          submitted && f['time'].errors
                      }" />

                    <div
                      *ngIf="submitted && f['time'].errors"
                      class="invalid-feedback">

                      <div *ngIf="f['time'].errors['required']">
                        Time is required
                      </div>
                    </div>
                  </div>
                </div>
                
               

                <div class="form-group row mb-3">
                  <label class="col-sm-3 col-form-label">
                    Haveli
                  </label>

                  <div class="col-sm-9">
                    <input
                      type="text"
                      formControlName="haveli"
                      class="form-control"
                      placeholder="Enter time slot"
                      [ngClass]="{
                        'is-invalid':
                          submitted && f['haveli'].errors
                      }" />

                    <div
                      *ngIf="submitted && f['haveli'].errors"
                      class="invalid-feedback">

                      <div *ngIf="f['haveli'].errors['required']">
                        Haveli is required
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Amount -->
                <div class="form-group row mb-3">
                  <label class="col-sm-3 col-form-label">
                    Amount
                  </label>

                  <div class="col-sm-9">
                    <input
                      type="number"
                      formControlName="amount"
                      class="form-control"
                      placeholder="Enter amount"
                      [ngClass]="{
                        'is-invalid':
                          submitted && f['amount'].errors
                      }" />

                    <div
                      *ngIf="submitted && f['amount'].errors"
                      class="invalid-feedback">

                      <div *ngIf="f['amount'].errors['required']">
                        Amount is required
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="col-sm-9 offset-sm-3">
              <button
                type="submit"
                class="btn btn-primary me-1">
                Submit
              </button>

              <button
                type="button"
                (click)="closePopup()"
                class="btn btn-light">
                Cancel
              </button>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends -->